/**
 * @author Kelnik
 *
 * SliderDescription - Слайдер с описанием
 */

import 'slick-carousel/slick/slick.css';
import 'slick-carousel';
import FullSlider from 'components/full-slider';
import tmplFull from './templates/tmplFull.twig';
import {TweenMax} from 'gsap';
import Utils from 'common/scripts/utils';

class SliderDescription {
    constructor(options) {
        this.options = options;
        this.container = options.container;

        this.trackSelector = '.j-slider-description-track';
        this.prevSelector = '.j-slider-description-prev';
        this.nextSelector = '.j-slider-description-next';
        this.slideSelector = '.j-slider-description-slide';
        this.currentSelector = '.j-slider-description-current';
        this.countSelector = '.j-slider-description-count';
        this.captionSelector = '.j-slider-description-caption';
        this.fullSelector = '.j-slider-description-full';

        this.slideImgSelector = '.j-slider-description-img';

        this.duration = options.duration || 0.6;
        this.ease = options.ease || 'ease-out';
        this.full = this.container ? Boolean(this.container.dataset.full) : false;
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._initSlider();
        this._initFull();
    }

    _initElements() {
        this.track = this.container.querySelector(this.trackSelector);
        this.prev = this.container.querySelector(this.prevSelector);
        this.next = this.container.querySelector(this.nextSelector);

        this.currentDescripion = this.container.querySelector(this.currentSelector);
        this.count = this.container.querySelector(this.countSelector);
        this.caption = this.container.querySelector(this.captionSelector);
    }

    _initSlider() {
        this.slider = $(this.track);

        this.slider.on('init reInit', (event, slick, currentSlide) => {
            this._setCount(slick.slideCount);
            this._setCurrent((currentSlide || 0) + 1);
            this._setCaption(currentSlide || 0, slick);
        });

        this.slider.on('beforeChange', this._beforeChange.bind(this));
        this.slider.on('afterChange', this._afterChange.bind(this));
        this.slider.on('setPosition', this._setPosition.bind(this));

        this.slider.slick({
            lazyLoad      : 'ondemand',
            infinite      : true,
            slidesToShow  : 1,
            slidesToScroll: 1,
            speed         : this.duration * 1000,
            adaptiveHeight: false,
            prevArrow     : this.prev,
            nextArrow     : this.next,
            fade          : true
        });
    }

    _initFull() {
        if (!this.full) {
            return;
        }

        this.track.insertAdjacentHTML('beforeend', tmplFull());

        this.fullEl = this.track.querySelector(this.fullSelector);

        if (this.fullEl) {
            this.fullSlider = new FullSlider();

            this.fullEl.addEventListener('click', () => {
                const pictures = Array.from(this.track.querySelectorAll('picture'));
                const images = pictures && pictures.length ? pictures : Array.from(this.track.querySelectorAll('img'));

                if (images && images.length) {
                    this.fullSlider.toOpen({elements: images});
                }
            });
        }
    }

    /* eslint-disable */
    _beforeChange(event, slick, currentSlide, nextSlide) {
        this._hideCaption();

        this.direction = this._getDirection(slick, currentSlide, nextSlide);
        this.currentSlideEl = slick.$slides.get(currentSlide);
        this.nextSlideEl = slick.$slides.get(nextSlide);

        this._setIndexSlide(this.currentSlideEl);
        this._animateSlideImage(this.currentSlideEl, this.nextSlideEl, this.direction);
    }

    _afterChange(event, slick, currentSlide) {
        const slide = slick.$slides.get(currentSlide);
        const imgEl = slide.querySelector(this.slideImgSelector);

        this._setDefaultIndexSlide(slick);
        this._clearJsStyles(imgEl);

        this._setCount(slick.slideCount);
        this._setCurrent((currentSlide || 0) + 1);
        this._setCaption(currentSlide || 0, slick);
    }

    _setPosition(event, slick) {
        this.current = slick.$slides.get(slick.currentSlide);

        setTimeout(() => {
            this._refreshSlideClip(this.current);
        }, 300);
    }

    _setDefaultIndexSlide(slick) {
        Array.from(slick.$slides).forEach((slide) => {
            slide.classList.remove('slick-prev');
        });
    }

    _animateSlideImage(currentSlideEl, nextSlideEl, direction) {
        const clip = this._calcClip(direction, nextSlideEl);

        this._toAnimate(clip, currentSlideEl, nextSlideEl);
    }

    _calcClip(direction, nextSlideEl) {
        const height = nextSlideEl.offsetHeight;
        const width = nextSlideEl.offsetWidth;

        if (direction === 'NEXT') {
            return {
                clipFrom: `rect(0, ${width}px, ${height}px, ${width}px)`,
                clipTo  : `rect(0, ${width}px, ${height}px, 0px)`
            };
        }

        return {
            clipFrom: `rect(0, 0, ${height}px, 0)`,
            clipTo  : `rect(0, ${width}px, ${height}px, 0px)`
        };
    }

    _toAnimate(clip, currentSlideEl, nextSlideEl) {
        const currentImageEl = currentSlideEl.querySelector(this.slideImgSelector);
        const nextImageEl = nextSlideEl.querySelector(this.slideImgSelector);

        TweenMax.set(nextImageEl, {
            clip : clip.clipFrom
        });

        TweenMax.to(currentImageEl, this.duration, {
            ease : this.ease
        });

        TweenMax.to(nextImageEl, this.duration, {
            clip : clip.clipTo,
            ease : this.ease
        });
    }

    _getDirection(slick, currentSlide, nextSlide) {
        const countSlide = slick.$slides.length;

        if (currentSlide === countSlide - 1 && nextSlide === 0) {
            return 'NEXT';
        }

        if (nextSlide === countSlide - 1 && currentSlide === 0) {
            return 'PREV';
        }

        if (currentSlide < nextSlide) {
            return 'NEXT';
        }

        return 'PREV';
    }

    _setIndexSlide(slide) {
        slide.classList.add('slick-prev');
    }

    _clearJsStyles(element) {
        if (!element) {
            return;
        }

        element.removeAttribute('style');
    }

    _refreshSlideClip(current) {
        const imageEl = current.querySelector(this.slideImgSelector);

        TweenMax.set(imageEl, {clip: `rect(0, ${current.offsetWidth}px, ${current.offsetHeight}px, 0px)`});
    }

    _setCaption(current, slick) {
        const currentEl = slick.$slides.get(current);
        const slide = currentEl.querySelector(this.slideSelector);
        const caption = slide.dataset.caption;

        this._replaceContent(this.caption, `${caption}`);
        this._showCaption();
    }

    _setCurrent(current) {
        this._replaceContent(this.currentDescripion, `${current}`);
    }

    _setCount(count) {
        this._replaceContent(this.count, `${count}`);
    }

    _replaceContent(elem, text) {
        Utils.clearHtml(elem);
        Utils.insetContent(elem, text);
    }

    _hideCaption() {
        this.caption.classList.add('is-hide');
    }

    _showCaption() {
        this.caption.classList.remove('is-hide');
    }
}

export default SliderDescription;
